import api from "./api";

export interface BackupArquivo {
  nome: string;
  tamanhoBytes: number;
  criadoEm: string;
  manual: boolean;
}

export interface BackupAgenda {
  intervaloDias: number;
  hora: number;
  minuto: number;
}

export interface BackupsListagem {
  arquivos: BackupArquivo[];
  webhookUrl: string;
  webhookEnv: boolean;
  agenda: BackupAgenda;
  proximaExecucao: string;
  ultimaExecucao: string | null;
}

export async function listarBackups() {
  const r = await api.get("/backups");
  return r.data.data as BackupsListagem;
}

export async function criarBackupManual() {
  const r = await api.post("/backups");
  return r.data.data as { criado: string; arquivos: BackupArquivo[] };
}

export async function apagarBackup(nome: string) {
  await api.delete(`/backups/${encodeURIComponent(nome)}`);
}

export async function reenviarBackupWebhook(nome: string) {
  await api.post(`/backups/${encodeURIComponent(nome)}/reenviar`);
}

export async function definirWebhookUrl(url: string) {
  const r = await api.put("/backups/webhook-url", { url });
  return r.data.data as { url: string };
}

export async function definirAgendaBackup(agenda: BackupAgenda) {
  const r = await api.put("/backups/agenda", agenda);
  return r.data.data as { agenda: BackupAgenda; proximaExecucao: string };
}

export function urlDownloadBackup(nome: string) {
  // Inclui token via interceptor do axios? Não — `<a href>` não passa headers.
  // Usamos rota direta com download via api.get blob, que herda o interceptor.
  return `/api/backups/${encodeURIComponent(nome)}/download`;
}

export async function baixarBackup(nome: string) {
  const r = await api.get(`/backups/${encodeURIComponent(nome)}/download`, { responseType: "blob" });
  // Cria URL temporária e dispara click. Limpa depois.
  const blob = new Blob([r.data], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nome;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
